<template>
  <div id="accessStoreInfo" ref="accessStoreInfo">
    <el-row class="clearfix" style="margin-bottom: 15px;">
      <el-col class="fl" :span="2">
        <el-button size="small" type="warning" @click="backGo()">返回</el-button>
      </el-col>
      <el-col class="fr" :span="1">
        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
      </el-col>
    </el-row>
    <el-col class="fl searthPart no-print" style="width: 19%;">
      <p class="headerT">物料配送信息</p>
      <el-form ref="returnForm" :model="returnForm" id="test" label-width="100px" :label-position="labelPosition">
        <el-form-item label="物料配送编号:">
          <el-input :disabled="true" :value="returnForm.code"></el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(returnForm.code,$event)"></i>
        </el-form-item>
        <el-form-item label="物料配送类型:">
          <el-input :disabled="true" v-model="returnForm.type"></el-input>
        </el-form-item>
        <el-form-item label="接收门店:">
          <el-input :disabled="true" v-model="returnForm.shopInputName"></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-input :disabled="true" v-if="returnForm.status == 4" value="已取消"></el-input>
          <el-input :disabled="true" v-else-if="returnForm.status == 3" value="已收货"></el-input>
          <el-input :disabled="true" v-else-if="returnForm.status == 2" value="已发货"></el-input>
          <el-input :disabled="true" v-else value="在库"></el-input>
        </el-form-item>
        <el-form-item label="操作人:">
          <el-input :disabled="true" v-model="returnForm.operatorName"></el-input>
        </el-form-item>
        <el-form-item label="提交时间:">
          <el-input :disabled="true" v-model="returnForm.createTime"></el-input>
        </el-form-item>
        <el-form-item label="备注信息:">
          <el-input :disabled="true" v-model="returnForm.memo"></el-input>
        </el-form-item>
        <el-form-item label="仓库类型:">
          <el-select  v-model="toWarehouseType" placeholder="请选择仓库类型" clearable :disabled="!isNull(FormToWarehouseType)||returnForm.status == 3" style="width: 85%;">
            <el-option v-for="(item,index) in warehouseList"
                       :label="item.paraName"
                       :value="item.paraCode"
                       :key="index">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col class="fr" style="width:78%;">
      <el-card class="box-card fr" style="width: 100%;">
        <el-table
          id="table"
          :data="returnData"
          border
          :header-cell-style="{'text-align':'center'}"
          :summary-method="getSummaries"
          show-summary
          style="width: 100%">
          <el-table-column
            align="center"
            type="index"
            width="50"
            label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialCode"
            label="物料编号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="modelName"
            label="型号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialName"
            label="物料名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sum"
            width="100"
            label="配送数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="inboundPrice"
            width="100"
            label="配送金额">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
            <template slot-scope="scope">
              <el-button @click.stop="showSerialNumber(scope.$index, scope.row)" type="text" size="small">查看序列号
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-col :span="24" class="toolbar">
          <div class="pagination">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pages.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pages.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="pages.total">
            </el-pagination>
          </div>
        </el-col>
      </el-card>
    </el-col>
    <!-- 查看序列号弹出框 -->
    <el-dialog class="dialog-content" :visible.sync="dialogTableVisible">
      <el-row
        class="dialog-code-content"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading">
        <el-col v-for="(item,index) in checkCodeList" v-if="item != ''" :key="index" :span="6">
          <p>{{item}}</p>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-button type="primary" v-show="returnForm.shopOutDept == deptId && returnForm.status == 2" class="fr"
               style="margin: 50px 20px 50px 0;" @click="cancelDelivery">取消配送
    </el-button>
    <el-button type="primary" v-show="returnForm.shopInputDepe == deptId && returnForm.status == 2" class="fr"
               style="margin: 50px 20px 50px 0;" @click="confirmRecive">确认收货
    </el-button>
  </div>
</template>
<script>
  import {hideLoading, showLoading} from "../../components/loading/loading";

  let moment = require("moment");
  import clip from '@/util/clipboard'
  import {
    cancel,
    confirmReceipt,
    selectTheShippingDelivery,
    selectDeliveryTheGoodsList, selectParameterInfoBusiness
  } from "../../api/api";

  export default {
    name: 'accessStoreInfo',
    components: {},
    data() {
      return {
        deptId: '',  //门店类型
        //分页变量
        pages: {
          total: 0,
          page: 1,
          pageSize: 10,
        },
        orderId: '',
        labelPosition: 'left',
        returnForm: {},
        returnData: [],
        dialogTableVisible: false, //弹出框
        checkCodeList: [], //序列号数组
        warehouseList:[] ,//仓库类型
        toWarehouseType:'',
        FormToWarehouseType:'',
      }
    },
    created: function () {
      this.$destroy(); //销毁生命周期
      this.deptId = JSON.parse(localStorage.getItem('userInfo')).deptId;
      if (!this.$route.query.orderId) {
        var userOrderId = sessionStorage.getItem('saveOrderId');
        this.orderId = JSON.parse(userOrderId);
      } else {
        let orderId = this.$route.query.orderId
        this.orderId = orderId
      }
      this.getSelectDeliveryTheGoods()     //获取出入库信息
      this.getSelectTheShippingDeliveryList() //获取物料信息
      this.getSelectParameterInfoBusiness()// 仓库类型
    },
    methods: {
      handleSizeChange(val) {
        this.pages.pageSize = val
        this.getSelectTheShippingDeliveryList()
      },
      handleCurrentChange(Page) {
        this.pages.page = Page
        this.getSelectTheShippingDeliveryList()
      },
      //获取订单详情
      getSelectDeliveryTheGoods() {
        let para = {
          code: this.orderId
        }
        selectTheShippingDelivery(para).then(res => {
          if (res.data.status == '100') {
            this.returnForm = res.data.results[0];
            this.returnForm.createTime = this.filters.formatDate(this.returnForm.createTime);
            this.returnForm.type = (this.returnForm.type == '1') ? '配送发货' : '配送收货';
            this.FormToWarehouseType=this.returnForm.toWarehouseType;
            this.toWarehouseType=this.returnForm.toWarehouseType;
            sessionStorage.setItem('saveOrderId', JSON.stringify(this.returnForm.code));
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //获取订单详情分页
      getSelectTheShippingDeliveryList() {
        let para = {
          code: this.orderId,
          startRow: this.pages.page,
          pageSize: this.pages.pageSize
        }
        selectDeliveryTheGoodsList(para).then(res => {
          if (res.data.status == '100') {
            this.returnData = res.data.results.list
            this.pages.total = res.data.results.total
            this.returnData.forEach((item, index) => {
              let arr = item.sn.split(',');
              arr.forEach((item1, index1) => {
                if (item1 == "" || typeof (item1) == "undefined") {
                  arr.splice(index1, 1);
                }
              })
              let obj = {
                materialCode: item.materialCode,
                materialName: item.materialName,
                list: arr
              }
              this.returnData[index].list = arr;
            })
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //查看序列号
      showSerialNumber(index, row) {
        this.dialogTableVisible = true
        this.checkCodeList = Object.assign({}, row).list
      },
      //复制内容
      handleCopy(text, event) {
        clip(text, event)
      },
      //返回上一页
      backGo() {
        if (this.returnForm.shopOutDept == this.deptId) {
          this.$router.push({
            path: '/materDeliveryManage'
          })
        } else {
          this.$router.push({
            path: '/materReceiveManage'
          })
        }

      },
      tabRemove(targetName) {
        // 首页不可删除
        if (targetName == '/') {
          return;
        }
        //将该tab从options里移除
        this.$store.commit('delete_tabs', targetName);
        ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
        if (this.activeIndex === targetName) {
          // 设置当前激活的路由
          if (this.options && this.options.length >= 1) {
            this.$store.commit('set_active_index', this.options[this.options.length - 1].route);
            this.$router.push({path: this.activeIndex});
          } else {
            this.$router.push({path: '/welcome'});
          }
        }
      },
      refresh() {
        this.getSelectTheShippingDeliveryList()
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index === 1 || index === 6) {
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = '';
          }
        });
        if (sums[4] > 0) {
          sums[5] = this.toThousands2(sums[5]);
        }
        return sums;
      },
      //金额转化函数
      addCommas: function (row, column) {
        var num = row[column.property];
        var b = num.toString().replace(/\$|\,/g, '');
        if (isNaN(num))
          num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num * 100 + 0.50000000001);
        var cents = num % 100;
        num = Math.floor(num / 100).toString();
        if (cents < 10)
          cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
          num = num.substring(0, num.length - (4 * i + 3)) + ',' +
            num.substring(num.length - (4 * i + 3));
        return (((sign) ? '' : '-') + num + '.' + cents);
      },
      toThousands2(num) {
        num = num.toString().replace(/\$|\,/g, '');
        if (isNaN(num))
          num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num * 100 + 0.50000000001);
        var cents = num % 100;
        num = Math.floor(num / 100).toString();
        if (cents < 10)
          cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
          num = num.substring(0, num.length - (4 * i + 3)) + ',' +
            num.substring(num.length - (4 * i + 3));
        return (((sign) ? '' : '-') + num + '.' + cents);
      },
      //取消配送
      cancelDelivery() {
        let para = {
          code: this.orderId
        };
        showLoading();
        cancel(para).then(res => {
          hideLoading();
          if (res.data.status == '100') {
            this.$message({
              message: '取消成功',
              type: "success"
            });
            this.tabRemove(this.$route.path)
            this.$router.replace({
              path: '/materDeliveryManage'
            })
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //确认收货
      confirmRecive() {
        let _seft=this;
        let para = {
          code: this.orderId,
          toWarehouseType:_seft.toWarehouseType
        };
        showLoading();
        confirmReceipt(para).then(res => {
          hideLoading();
          if (res.data.status == '100') {
            this.$message({
              message: '确认成功',
              type: "success"
            });
            this.tabRemove(this.$route.path)
            this.$router.replace({
              path: '/materReceiveManage'
            })
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //获取物料转出仓库列表
      getSelectParameterInfoBusiness(){
        let para={
          paraType: 'warehouse_type'
        }
        selectParameterInfoBusiness(para).then(res => {
          if (res.data.status==100) {
            this.warehouseList = res.data.results.list
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      isNull(value){
        if (value==null){
          return true;
        }
        if (value === undefined){
          return true;
        }
        if (value.length==0){
          return true;
        }
        return false
      }
    },
    computed: {},
    watch: {},
  }
</script>


<style type="text/css" lang="scss" scoped>
  #accessStoreInfo {
    font-size: 14px;

    .copyBtn {
      font-size: 24px;
      cursor: pointer;
      display: block;
      float: right;
    }

    .el-input {
      width: 85%;
    }

    .headerT {
      font-size: 16px;
      margin: 0 0 15px 0;
    }

    .activeBtn {
      background-color: #1abc9c;
      color: #fff;
    }

    .eventLi {
      border-left: 1px solid #1abc9c;
      padding-bottom: 20px;

      .childSpan {
        padding-left: 20px;
        margin-bottom: 5px;
      }

      .childSpan:first-child {
        padding-left: 0px;
        margin: -5px 0 0 -5px;
      }

      .childSpan span.orderId {
        color: #3399FF;
      }

      .createTime i {
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 20px;
        background-color: #1abc9c;
        margin: 0px 15px 0px -5px;
      }
    }

    .toolbar {
      margin: 20px 0;
    }

    .el-button + .el-button {
      margin-left: 0px;
    }

    .el-step__line {
      background-color: #1abc9c;
    }

    .el-step__icon-inner {
      color: #1abc9c;
    }

    /*.el-step__icon{width: 10px;height: 10px;}*/
    .el-step__icon.is-text {
      border-color: #1abc9c;
    }
  }

  .dialog-content {
    width: 900px;
    margin: 0 auto;

    .dialog-code-content {
      text-align: center;

      .el-col {
        p {
          border: 1px solid #e3e3e3;
          line-height: 40px
        }

      }
    }
  }

</style>



// WEBPACK FOOTER //
// materDeliveryInfo.vue?349c4b92